import { useQuery } from "@tanstack/react-query";
import { listCaptures } from "../../api/captures";
import { Capture } from "../../types/model/capture";

const NO_CAPTURES: Capture[] = [];
const STALE_TIME = 5 * 60 * 1000;

export const useAllCaptures = () => {
  const query = useQuery({
    queryKey: ["captures", "all-for-filters"],
    queryFn: async () => {
      const response = await listCaptures();
      if (response.total > response.data.length) {
        const full = await listCaptures(undefined, undefined, undefined, undefined, response.total);
        return full.data;
      }
      return response.data;
    },
    staleTime: STALE_TIME,
  });

  return query.data ?? NO_CAPTURES;
};